import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useHealth } from '../api/use-health'
import { api } from '../api/client'

export function Upload() {
  const { health } = useHealth()
  const [file, setFile] = useState<File | null>(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [result, setResult] = useState<unknown>(null)

  if (!health) {
    return <p className="text-text-dim">Sunucu denetleniyor…</p>
  }
  if (health.mode !== 'live') {
    return (
      <div className="border border-warn/40 bg-warn/5 rounded p-4 max-w-2xl">
        <h1 className="text-warn font-medium mb-1">Yükleme şu anda devre dışı</h1>
        <p className="text-sm text-text-dim">
          Kendi DICOM dosyanızı yüklemek için sunucunun canlı modda çalışması gerekir. Bu
          oturumda yalnızca seçilmiş{' '}
          <Link to="/cases" className="text-accent">demo vakalar</Link> görüntülenebilir.
        </p>
      </div>
    )
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (!file) return
    setBusy(true)
    setError(null)
    setResult(null)
    try {
      const r = await api.uploadDicomZip(file)
      setResult(r)
    } catch (err) {
      setError(String(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-semibold text-text mb-2">Görüntü yükle</h1>
      <p className="text-text-dim text-sm mb-4">
        Tek bir kontrastlı meme MR çalışmasının (birden çok faz içeren) DICOM
        dosyalarını ZIP biçiminde yükleyin. Sunucu lezyon segmentasyonu yapar, 3 boyutlu
        modeli üretir ve iki sınıflandırıcıyı çalıştırır. Sonuç demo vakalarla aynı
        biçimde gösterilir.
      </p>
      <p className="text-text-dim text-xs mb-4">
        Bu sayfa yalnızca araştırma amaçlıdır. Yüklediğiniz görüntülerin kişi tanımlayıcı
        bilgilerden arındırılmış olduğundan emin olun.
      </p>
      <form onSubmit={submit} className="border border-border rounded bg-surface p-4">
        <input
          type="file"
          accept=".zip"
          onChange={(e) => setFile(e.target.files?.[0] || null)}
          className="block w-full text-sm text-text-dim file:mr-3 file:py-1.5 file:px-3 file:rounded file:border-0 file:bg-surface-2 file:text-text mb-3"
        />
        <button
          type="submit"
          disabled={!file || busy}
          className="px-4 py-2 bg-accent text-accent-fg rounded font-medium disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {busy ? 'Analiz çalışıyor…' : 'Analizi başlat'}
        </button>
      </form>
      {error && (
        <div className="mt-4 border border-malignant/40 bg-malignant/5 rounded p-3 text-malignant text-sm">
          {error}
        </div>
      )}
      {result !== null && (
        <pre className="mt-4 bg-surface-2 rounded p-3 text-xs overflow-auto">
          {JSON.stringify(result, null, 2)}
        </pre>
      )}
    </div>
  )
}
